
import React from 'react';
import {
  Switch,
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import "css/r-board.css";
import { BlockX } from 'main/page/blockx';
import { MichaelClinton } from 'main/page/michael-clinton';

const Board = () =>{
    return (
      <>
    		<Router basename={'/epool'}>
    	     <div className="r-board">
            <Switch>
              <Route exact path="/index.html">
                
                  <BlockX/>
                
              </Route>
              <Route path="/blockx">
                
                  <BlockX/>
                
              </Route>
              <Route path="/michael-clinton">
                
                  <MichaelClinton/>
                
              </Route>
              <Route exact path="/404" >
                <div className="boardbody">
                    <h5 className="fade-in align-self-center" style={{textAlign: 'center'}}>
                      <h2><b>404 Not found</b></h2><br/><br/>
                    </h5>
                </div>
              </Route>
              <Route exact path="/">
                <div className="boardbody">
                  <BlockX/>
                </div>
              </Route>
            </Switch>
          </div>
    		</Router>
    	</>
    )
}
export default Board;
